

























































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ajax from '@/lib/ajax';
import { PayrollRunDetailsModule, emptyAvailableTimesheetFilter } from '@/store/modules/payrollRunDetails';
import WorkerProfileSearchRequest from '@/models/Workers/WorkerProfileSearchRequest';
import WorkerStatus from '@/models/Workers/WorkerStatus';
import WorkType from '@/models/Shared/WorkType';

@Component({
    name: 'PayrollRunTimesheetFilter'
})
export default class extends GiganautVueDialog {
  @Prop({ required: true }) runId!: string;
  // The agency's payroll go-live floor (yyyy-MM-dd) — the default and the
  // earliest permitted "worked from" date (the backend clamps to it).
  @Prop({ default: '' }) availableFrom!: string;

  public dialog = false;
  public loadingOptions = false;

  public branches: any[] = [];
  public desks: any[] = [];
  public workers: any[] = [];

  public branchId: string | null = null;
  public deskId: string | null = null;
  public workerId: string | null = null;
  public from = '';
  public approvedFrom = '';
  public approvedTo = '';

  get isFilterActive(): boolean {
    const f = PayrollRunDetailsModule.availableFilter;
    return !!(f.branchId || f.deskId || f.workerId || f.from || f.approvedFrom || f.approvedTo);
  }

  // Desk list narrows to the chosen branch; unfiltered otherwise.
  get deskOptions(): any[] {
    if (!this.branchId) return this.desks;
    return this.desks.filter(d => d.branchId === this.branchId);
  }

  // The run passes the floor as an ISO date-time; the date input and the
  // API's from param both want yyyy-MM-dd.
  get availableFromDate(): string {
    return this.availableFrom ? this.availableFrom.substring(0, 10) : '';
  }

  get fromHint(): string {
    return this.availableFromDate
      ? `Defaults to the payroll go-live date (${this.availableFromDate}); earlier dates are ignored`
      : '';
  }

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (!val) return;
    // Seed the inputs from the applied filter so reopening shows reality.
    const f = PayrollRunDetailsModule.availableFilter;
    this.branchId = f.branchId || null;
    this.deskId = f.deskId || null;
    this.workerId = f.workerId || null;
    this.from = f.from || this.availableFromDate;
    this.approvedFrom = f.approvedFrom || '';
    this.approvedTo = f.approvedTo || '';
    if (this.branches.length === 0) {
      await this.loadOptions();
    }
  }

  onBranchChanged() {
    // A desk from another branch can't survive a branch change.
    if (this.deskId && !this.deskOptions.some(d => d.id === this.deskId)) {
      this.deskId = null;
    }
  }

  async loadOptions() {
    this.loadingOptions = true;
    try {
      // Same worker-profile search every candidate picker uses (see
      // QuickBook): active temp candidates from the profiles endpoint.
      const workerRequest = new WorkerProfileSearchRequest();
      workerRequest.statuses.push(WorkerStatus.Active);
      workerRequest.workTypes.push(WorkType.Temp);
      const [branches, desks, workers] = await Promise.all([
        ajax.get('/api/v1/agency/branches'),
        ajax.get('/api/v1/agency/desks'),
        ajax.post('/api/v1/agency/workers/search', workerRequest),
      ]);
      this.branches = branches.data || [];
      this.desks = desks.data || [];
      this.workers = workers.data || [];
    } catch (e: any) {
      // Leave lists empty; the selects just have nothing to offer.
    } finally {
      this.loadingOptions = false;
    }
  }

  async apply() {
    this.dialog = false;
    await PayrollRunDetailsModule.applyAvailableFilter({
      runId: this.runId,
      filter: {
        branchId: this.branchId || '',
        deskId: this.deskId || '',
        workerId: this.workerId || '',
        // The floor is the default — only send a date that differs from it.
        from: this.from && this.from !== this.availableFromDate ? this.from : '',
        approvedFrom: this.approvedFrom || '',
        approvedTo: this.approvedTo || '',
      },
    });
  }

  async clear() {
    this.branchId = null;
    this.deskId = null;
    this.workerId = null;
    this.from = this.availableFromDate;
    this.approvedFrom = '';
    this.approvedTo = '';
    this.dialog = false;
    await PayrollRunDetailsModule.applyAvailableFilter({
      runId: this.runId,
      filter: emptyAvailableTimesheetFilter(),
    });
  }
}
